import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'resolveRegionalNonRegional'
})
export class ResolveRegionalNonRegionalPipe implements PipeTransform {
    transform(description: string | null | undefined, isRegional: boolean): string {
        if (!description) return '';

        let out = description;

        if (description.includes('Regional/Non-Regional')) {
            const regex = /Regional\/Non-Regional/g;
            out = isRegional ? description.replace(regex, 'Regional') : description.replace(regex, 'Non-Regional');
        }

        return out;
    }
}
